import React, {useEffect} from 'react';
import {markerdata} from './data';
import {flagimg} from '../../../config/images';
import {CourseTitle} from './style';

const MapCourseFive = ({lat = 34.93342, lng = 127.51992}) => {
	useEffect(() => {
		const {kakao} = window;
		const mapContainer = document.getElementById('mapfive');

		if (!kakao || !mapContainer) {
			return;
		}

		const location = new kakao.maps.LatLng(lat, lng);

		const mapOptions = {
			center: location,
			level: 5,
		};

		// 지도 생성
		const kakaoMap = new kakao.maps.Map(mapContainer, mapOptions);

		// 출발·도착 깃발 마커 이미지
		const myMarker = flagimg;
		const myMarkerSize = new kakao.maps.Size(30, 30);
		const myMarkerOption = {
			offset: new kakao.maps.Point(4, 30),
		};

		const myMarkerPosition = new kakao.maps.MarkerImage(
			myMarker,
			myMarkerSize,
			myMarkerOption,
		);

		// 마커와 라벨 표시
		markerdata.forEach((el, i) => {
			const markerPosition = new kakao.maps.LatLng(el.lat, el.lng);

			// 첫 번째 마커는 깃발 이미지 사용
			if (i === 0) {
				const marker = new kakao.maps.Marker({
					map: kakaoMap,
					position: markerPosition,
					image: myMarkerPosition,
				});

				marker.setMap(kakaoMap);
			} else {
				const originMarker = new kakao.maps.Marker({
					map: kakaoMap,
					position: markerPosition,
				});

				originMarker.setMap(kakaoMap);
			}

			const customOverlay = new kakao.maps.CustomOverlay({
				position: markerPosition,
				content: `
					<div
						class="label"
						style="margin: -55px auto;"
					>
						<span class="left"></span>

						<span
							class="center"
							style="
								color: black;
								background-color: white;
								border-radius: 7px;
								padding: 1px 10px;
								border: solid 1px #d9d9d9;
							"
						>
							${el.title}
						</span>

						<span class="right"></span>
					</div>
				`,
			});
			var textOverlay = new kakao.maps.CustomOverlay({
				position: new kakao.maps.LatLng(
					34.935612500084716,
					127.51536750194902,
				),
				content:
					'<div style="padding:2px; background-color:#f5f5f5; border: 2px solid #4489c5ff; border-radius:5px; font-size: 13px;">갈 때만 이용</div>',
				zIndex: 3,
			});
			customOverlay.setMap(kakaoMap);
			textOverlay.setMap(kakaoMap);
		});

		// 지도 타입 컨트롤
		const mapTypeControl = new kakao.maps.MapTypeControl();

		kakaoMap.addControl(
			mapTypeControl,
			kakao.maps.ControlPosition.TOPRIGHT,
		);

		// 확대·축소 컨트롤
		const zoomControl = new kakao.maps.ZoomControl();

		kakaoMap.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

		/*
		 * 기본 실선 경로
		 *
		 * 점선 구간은 이 배열에서 제외하고
		 * 별도의 lineDashPath로 표현합니다.
		 */
		const linePath = [
			new kakao.maps.LatLng(34.93824533293566, 127.51941208098545), // 팔마종합운동장

			new kakao.maps.LatLng(34.937598321503366, 127.51894827556737),

			new kakao.maps.LatLng(34.93688601670695, 127.51899851768951),

			new kakao.maps.LatLng(34.934754076164225, 127.5190398158165),

			new kakao.maps.LatLng(34.93457, 127.5197),

			new kakao.maps.LatLng(34.93448889217353, 127.51992472670887),

			new kakao.maps.LatLng(34.93417238688551, 127.5201635284935),

			new kakao.maps.LatLng(34.93402349912809, 127.52020089743351),

			new kakao.maps.LatLng(34.933852382067116, 127.52016698102369),

			new kakao.maps.LatLng(34.933690887606886, 127.51999083604403),

			new kakao.maps.LatLng(34.93339129764623, 127.51943620761327), // 사거리

			new kakao.maps.LatLng(34.93205301270009, 127.51407560420807),

			new kakao.maps.LatLng(34.93020681773985, 127.51475361481762),

			new kakao.maps.LatLng(34.93042853732609, 127.51560870293346),

			new kakao.maps.LatLng(34.929523439948404, 127.51595327341062),

			new kakao.maps.LatLng(34.92932218880794, 127.51505454267938),

			new kakao.maps.LatLng(34.927467253069906, 127.51566678783557),
		];

		/*
		 * 점선 경로
		 *
		 * 갈 때 또는 별도 안내가 필요한 경로
		 */
		const lineDashPath = [
			new kakao.maps.LatLng(34.935612500084716, 127.51536750194902),

			new kakao.maps.LatLng(34.934754076164225, 127.5190398158165),
		];

		// 기본 실선
		const polyline = new kakao.maps.Polyline({
			path: linePath,
			strokeWeight: 5,
			strokeColor: '#005bac',
			strokeOpacity: 1,
			strokeStyle: 'solid',
		});

		// 별도 점선
		const polylineDash = new kakao.maps.Polyline({
			path: lineDashPath,
			strokeWeight: 3,
			strokeColor: '#4489c5',
			strokeOpacity: 1,
			strokeStyle: 'dash',
		});

		polyline.setMap(kakaoMap);
		polylineDash.setMap(kakaoMap);

		// 컴포넌트 제거 시 지도 선 제거
		return () => {
			polyline.setMap(null);
			polylineDash.setMap(null);
		};
	}, [lat, lng]);

	return (
		<>
			<CourseTitle>5km</CourseTitle>

			<div
				id='mapfive'
				style={{
					width: '100%',
					height: '650px',
				}}
			/>
		</>
	);
};

export default MapCourseFive;
